<style>
    .cc-input-html-description {
        max-height: 200px;
        overflow: scroll;
    }
</style>

<template>
    <div>
        <b-form-group
                class="c-text"
                :label-for="id"
                :label-cols="labelCols"
                :label="label"
                :description="description">
            <template slot="description">
                <p class="cc-input-html-description" v-html="value"></p>
            </template>
        </b-form-group>
    </div>
</template>

<script>
  export default {
      name: 'InputHTML',
      props: {
          required: {
              type: Boolean,
              default: false
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          value: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          _isVisible: {
              type: Boolean,
              default: true
          },
          form: {
              type: Object,
              default: function() {return {}}
          },
          fieldRefs: {
              type: Array,
              default: function() { return [] }
          }
      },
      watch: {
      },
      mounted() {
          this.dataIsVisible = this._isVisible
      },
      data: () => {
          return {
              dataValue: '',
              dataIsVisible: true,
              Core: window.Core
          }
      },
      computed: {
          isVisible: {
              set(val) {
                  this.dataIsVisible = val
              },
              get() {
                  return this.dataIsVisible
              }
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          }
      }
  }
</script>